import { Injectable, NgZone, inject } from "@angular/core";
import { PluginInjectorService } from "core-client/api";
import { AllyServiceClass } from './lib/classes/ally-service.class';

/**
 * This class is identical to the AllyServiceClass class.
 * 
 * This class however is a service.
 * @extends AllyServiceClass
 * @see AllyServiceClass
 */
@Injectable({
  providedIn: "root",
})
export class AllyService extends AllyServiceClass {
  private readonly ngZone: NgZone = inject(NgZone);

  constructor(private _pluginInjectorService: PluginInjectorService) {
    super(_pluginInjectorService);
  }

  // Outside the zone: the observers only write attributes.
  override init(): void {
    this.ngZone.runOutsideAngular(() => super.init());
  }
}
